import React from "react";
import { useNavigate } from "react-router-dom";
import KernteamLayout from '../KernteamLayout';
import BackArrow from '../BackArrow';
import "./Arbeit.css";

function Arbeit() {
  const navigate = useNavigate();

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/kernteamportal" />
        <h1 className="section-title orange">Arbeit</h1>
        <div className="button-container">
          <button className="button_boring_red orange" onClick={() => navigate("/jobs_kinder")}>
            <span className="material-symbols-outlined">view_list</span>
            Übersicht Jobs/Kinder
          </button>
          <button className="button_boring_red orange" onClick={() => navigate("/jobszuteilen")}>
            <span className="material-symbols-outlined">business_center</span>
            Jobzuweisung
          </button>
          <button className="button_boring_red orange" onClick={() => navigate("/job_bearbeiten")}>
            <span className="material-symbols-outlined">edit</span>
            Job bearbeiten
          </button>
          <button className="button_boring_red orange" onClick={() => navigate("/jobsverwaltung")}>
            <span className="material-symbols-outlined">work_history</span>
            Jobverfügbarkeiten verwalten
          </button>
          <button className="button_boring_red orange" onClick={() => navigate("/jobs_hinzufuegen")}>
            <span className="material-symbols-outlined">add_circle</span>
            Neuen Job hinzufügen
          </button>
          <button className="button_boring_red orange" onClick={() => navigate("/jobsmarkieren")}>
            <span className="material-symbols-outlined">map</span>
            Job auf Karte markieren
          </button>

          <button className="button_boring_red orange" onClick={() => navigate("/einheiten-aktivieren")}>
            <span className="material-symbols-outlined">toggle_on</span>
            Einheiten aktivieren/deaktivieren
          </button>
          <button className="button_boring_red orange" onClick={() => navigate("/kind_spezialwunsch")}>
            <span className="material-symbols-outlined">stars_2</span>
            Spezialwunsch erfüllen
          </button>
        </div>
      </div>
    </KernteamLayout>
  );
}

export default Arbeit;